/**
 * A place for storing urls for later use in XHR requests.
 */

import BaseStore from 'fluxible/addons/BaseStore';

class UrlStore extends BaseStore {
    static storeName = 'UrlStore';

    static handlers: { [key: string]: keyof UrlStore } = {
        LOAD_URLS: 'loadUrls',
    };

    urls = new Map<string, string>();

    loadUrls(payload: { urls: { [key: string]: string } }) {
        Object.keys(payload.urls).map(key => {
            this.urls.set(key, payload.urls[key]);
        });
    }

    urlFor(key: string): string {
        if (this.urls.has(key)) {
            return this.urls.get(key) as string;
        } else {
            throw new Error(`Missing URL for key: ${key}`);
        }
    }
}

export default UrlStore;
